import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Logo, Panel, Btn, Field, Input } from "@/components/kit";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Missing reset token");
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — you can now sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="bd-page flex flex-col items-center justify-center px-6 py-10">
      <Link to="/" className="mb-8"><Logo /></Link>
      <Panel className="w-full max-w-md p-8 bd-fade-up">
        <h1 className="font-head text-2xl font-bold text-white mb-1">Set a new password</h1>
        <p className="text-sm text-purple-300/70 mb-6">Choose a new password for your BeetDrop account.</p>
        <form onSubmit={submit} className="space-y-4">
          <Field label="New password"><Input data-testid="rp-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" /></Field>
          <Btn type="submit" className="w-full" disabled={busy} data-testid="rp-submit">{busy ? "Saving…" : "Update password"}</Btn>
        </form>
        <div className="mt-5 text-center text-sm text-purple-300/70">
          <Link to="/login" className="font-semibold text-[#FF6B7D]">Back to sign in</Link>
        </div>
      </Panel>
    </div>
  );
}
